import styled from '@emotion/styled';
import {alpha} from '@mui/material';
import TablePagination from '@mui/material/TablePagination';
import PropTypes from 'prop-types';

const StyledPagination = styled(TablePagination)(({theme}) => ({
  overflow: 'visible',

  '& .MuiTablePagination-toolbar': {
    padding: '0 8px !important',
    display: 'flex',
    alignItems: 'center',
  },

  '& .MuiTablePagination-spacer': {
    display: 'none',
  },

  '& .MuiTablePagination-displayedRows': {
    fontSize: 13,
    fontWeight: 600,
    fontFamily: theme.typography.fontFamily,
    color: theme.palette.text.secondary,
    letterSpacing: '0.5px',
  },

  '& .MuiTablePagination-actions': {
    marginLeft: '4px !important',

    // Target the specific button class used by pagination
    '& .MuiButtonBase-root': {
      padding: 2,
      borderRadius: 4,
      color: theme.palette.text.primary,
      transition: 'all 0.2s ease',

      '& .MuiSvgIcon-root': {
        // Specificity fix: target the icon root
        fontSize: 20,
        display: 'block',
        color: 'inherit', // Forces the icon to take the button's color
      },

      '&:hover': {
        backgroundColor: alpha(theme.palette.primary.main, 0.08),
        color: theme.palette.primary.main,
      },

      '&.Mui-disabled': {
        color: theme.palette.action.disabled,
        '& .MuiSvgIcon-root': {
          color: 'inherit', // Ensures the SVG also looks disabled
        },
      },
    },
  },
}));

const AppsPagination = ({
  totalRows,
  page,
  onPageChange,
  pageSize = 15,
  ...rest
}) => {
  const safePage = totalRows <= 0 ? 0 : page;

  return (
    <StyledPagination
      component='div'
      count={totalRows}
      rowsPerPage={pageSize}
      page={safePage}
      backIconButtonProps={{'aria-label': 'Previous Page'}}
      nextIconButtonProps={{'aria-label': 'Next Page'}}
      onPageChange={onPageChange}
      rowsPerPageOptions={[]}
      {...rest}
    />
  );
};

AppsPagination.propTypes = {
  totalRows: PropTypes.number.isRequired,
  page: PropTypes.number.isRequired,
  onPageChange: PropTypes.func.isRequired,
  pageSize: PropTypes.number,
};

export default AppsPagination;
